class Quiz {
  constructor() {
    this.el = document.querySelector('.knowledge-test')
    this.correctCount = 0
    this.clickedCount = 0
    this.questionCount = this.el?.querySelectorAll('.question')?.length
    this.finalResult = this.el?.querySelector('.final-result')
  }

  /**
   * Initialize quiz
   */
  init() {
    if (this.el) {
      this.addListeners()
    }
  }

  /**
   * Add listeners to inputs
   */
  addListeners() {
    const inputs = this.el.querySelectorAll('input')
    if (inputs) {
      inputs.forEach(input => {
        input.addEventListener('click', () => {
          const correct = input.value === '1' ? true : false
          const className = correct ? 'correct' : 'wrong'
          const questionEl = input.closest('.question')
          this.clickedCount++
          correct ? this.correctCount++ : []
          this.showDescription(questionEl, className)
          questionEl.querySelectorAll('input').forEach((el) => {
            el.setAttribute('disabled', true)
          })
          this.refreshStatus()
        })
      })
    }
  }

  /**
   * Show description of question
   * @param {element} questionEl element of question
   * @param {string} className class name, (correct || wrong)
   */
  showDescription(questionEl, className) {
    questionEl.classList.add(className)
    questionEl.querySelector(`.result-${className}`).classList.add('show')
    questionEl.querySelector('.description').classList.add('show')
  }

  /**
   * Refresh status of the quiz (if last question show result)
   */
  refreshStatus() {
    if (this.clickedCount >= this.questionCount) {
      document.querySelector('.main-content-area').innerHTML = this.getFinalResult()
      // this.finalResult.innerHTML = this.getFinalResult()
      // this.finalResult.classList.add('show')
    }
  }

  /**
   * Get text and return it as raw html
   * @returns {string} raw html
   */
  getFinalResult(){
    var html = ''; //'<h3>' + window.STAGE_TRANSLATIONS.score + ' ' +this.correctCount+'/'+ this.questionCount +' ' + window.STAGE_TRANSLATIONS.points + '</h3>';

    if(typeof(window.resultTexts) === 'object'){
      var heading = '', description = '', image = '';

      for(var i=0; i < window.resultTexts.length; i++){
        var scoreText = window.resultTexts[i];
        if(scoreText.minScore <= this.correctCount){
          heading = scoreText.heading;
          description = scoreText.text;
          image = scoreText.image;
          break;
        }
      }

      html += '<h1 class="knowledge-test__final-heading">'+heading+'</h1>';
      html += `<p><img src="${image}" alt=""></p>`;
      html += '<p>'+description+'</p>';
      html += `<a href="#" onclick="location.reload(); return false;" class="button lightblue">${window.STAGE_TRANSLATIONS.tryagain}</a>`;
      html += '<a id="facebook-share" class="fb-share" href="#"></a>';
    }

    return html;
  }
}

export default new Quiz()
